import { Component } from 'react';
import { logger } from '@fiverr-private/obs';

interface ErrorBoundaryState {
    hasError: boolean;
}

class ErrorBoundary extends Component<any, ErrorBoundaryState> {
    static getDerivedStateFromError() {
        return {
            hasError: true,
        };
    }

    constructor(props: any) {
        super(props);

        this.state = {
            hasError: false,
        };
    }

    override componentDidCatch(error) {
        logger.error(error);
    }

    override render() {
        const { hasError } = this.state;

        if (hasError) {
            return null;
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
